import { checkArrayUniqueLabels } from '../lib';

const validators = [
    checkArrayUniqueLabels('global.contactOriginTypes', {
        requiredError: 'Veuillez saisir une origine ou la supprimer',
        duplicateError: 'Cette origine existe déjà',
    }),
];

export default validators;
